"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.STATISTICS_MAPPING = {
    prefix: 'statistics',
    getResidentsStatistics: {
        path: '/getResidentsStatistics'
    },
    getFacilityStatistics: {
        path: '/getFacilityStatistics'
    },
    getStatementsStatistics: {
        path: '/getStatementStatistics'
    },
    getStatementsBatchStatistics: {
        path: '/getStatementBatchStatistics',
        parameter: '/:batchId'
    },
    getStatementsBatchDashboardStatistics: {
        path: '/getStatementsBatchDashboardStatistics',
        parameter: '/:batchId'
    },
    getWorkStatistics: {
        path: '/getWorkStatistics'
    }
};
